import mutations from './drugEquivArchive.mutations'
import actions from './drugEquivArchive.actions'
import getters from './drugEquivArchive.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
